import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=b19422c6&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=b19422c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19422c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19422c6')) {
      api.createRecord('b19422c6', component.options)
    } else {
      api.reload('b19422c6', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=b19422c6&scoped=true&", function () {
      api.rerender('b19422c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/elements/modal/Modal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/elements/modal/Modal.vue
// module id = wWAe
// module chunks = 31